import {
  subtype as s,
  subtypeCatalog as c,
  withSubtypeImages as withImages,
} from './catalog-builder';

export const VEHICLE_PRODUCT_SUBTYPE_CATALOGS = [
  c(
    'car',
    ['Car', 'Cars'],
    withImages('car', [
      s('sedan', 'Sedan', 'three-box body', 'four-door passenger cabin'),
      s('hatchback', 'Hatchback', 'two-box body', 'rear roof-hinged liftgate'),
      s('coupe', 'Coupe', 'two-door passenger cabin', 'fixed sloping roof'),
      s(
        'convertible',
        'Convertible',
        'retractable or removable roof',
        'open passenger cabin'
      ),
      s(
        'wagon',
        'Wagon',
        'elongated roofline',
        'rear cargo body with liftgate'
      ),
      s('suv', 'SUV', 'tall enclosed body', 'raised ride height'),
      s(
        'crossover',
        'Crossover',
        'unified car-like body',
        'moderately raised ride height'
      ),
      s(
        'pickup-truck',
        'Pickup truck',
        'enclosed front cabin',
        'open rear cargo bed'
      ),
      s('van', 'Van', 'tall enclosed box body', 'long continuous roofline'),
      s(
        'minivan',
        'Minivan',
        'tall passenger cabin',
        'sliding side-door opening'
      ),
      s(
        'sports-car',
        'Sports car',
        'low wide body',
        'compact performance cabin'
      ),
      s(
        'off-road',
        'Off-road',
        'high ground clearance',
        'short body overhangs',
        'pronounced wheel arches'
      ),
    ])
  ),
  c(
    'wheel',
    ['Wheel', 'Wheels'],
    withImages('wheel', [
      s(
        'five-spoke',
        'Five-spoke',
        'five primary spokes',
        'open spoke windows'
      ),
      s(
        'split-five-spoke',
        'Split five-spoke',
        'five paired spoke groups',
        'ten outer spoke ends'
      ),
      s(
        'multi-spoke',
        'Multi-spoke',
        'many evenly spaced slender spokes',
        'open perimeter windows'
      ),
      s('mesh', 'Mesh', 'crossing spoke lattice', 'dense repeated openings'),
      s(
        'turbine',
        'Turbine',
        'directional swept spokes',
        'continuous rotational pattern'
      ),
      s(
        'aero-disc',
        'Aero disc',
        'mostly closed wheel face',
        'small cooling openings'
      ),
      s(
        'steel',
        'Steel',
        'pressed solid wheel face',
        'repeated ventilation holes'
      ),
      s(
        'wire-spoke',
        'Wire-spoke',
        'many thin radial wires',
        'visibly laced hub-to-rim structure'
      ),
      s(
        'deep-dish',
        'Deep-dish',
        'recessed wheel center',
        'wide projecting outer lip'
      ),
      s('concave', 'Concave', 'inward-set hub', 'spokes rising toward the rim'),
      s(
        'beadlock',
        'Beadlock',
        'bolted outer retaining ring',
        'reinforced off-road rim edge'
      ),
      s(
        'multi-piece',
        'Multi-piece',
        'separate center and rim sections',
        'visible perimeter assembly hardware'
      ),
    ])
  ),
  c(
    'tire',
    ['Tire', 'Tires', 'Tyre', 'Tyres'],
    withImages('tire', [
      s(
        'passenger-touring',
        'Passenger touring',
        'moderate sidewall height',
        'fine multi-rib road tread'
      ),
      s(
        'performance-road',
        'Performance road',
        'low-profile sidewall',
        'wide shoulder blocks',
        'asymmetric road tread'
      ),
      s('winter', 'Winter', 'dense tread siping', 'open snow-clearing grooves'),
      s(
        'studded-winter',
        'Studded winter',
        'dense winter siping',
        'visible tread studs'
      ),
      s(
        'all-terrain',
        'All-terrain',
        'interlocking tread blocks',
        'reinforced open shoulders'
      ),
      s(
        'mud-terrain',
        'Mud-terrain',
        'large separated tread lugs',
        'aggressive sidewall lugs'
      ),
      s(
        'highway-terrain',
        'Highway terrain',
        'continuous highway ribs',
        'closed stable shoulders'
      ),
      s(
        'commercial-truck',
        'Commercial truck',
        'tall reinforced sidewall',
        'deep heavy-duty tread'
      ),
      s(
        'trailer',
        'Trailer',
        'straight tracking ribs',
        'stiff load-bearing sidewall'
      ),
      s(
        'temporary-spare',
        'Temporary spare',
        'narrow compact tread',
        'tall lightweight sidewall'
      ),
      s(
        'track-slick',
        'Track slick',
        'wide smooth tread face',
        'low rigid sidewall'
      ),
      s(
        'drag-slick',
        'Drag slick',
        'smooth extra-wide tread',
        'tall flexible sidewall'
      ),
    ])
  ),
] as const;
